import { gql } from '@apollo/client';

const GET_FEELINGS_MATCH_ACTIVITY = gql`
  query feelingsMatch($where: ActivityWhereInput!) {
    feelingsMatch(where: $where) {
      id
      title
      book {
        title
        characters {
          id
          character
          characterCase
          characterType
        }
      }
      rounds {
        instructions {
          end {
            id
            src
            description
            captions
          }
          introduction {
            id
            src
            description
            captions
          }
        }
        cardFront {
          id
          src
          description
        }
        cards {
          affirmation {
            id
            src
            description
            captions
          }
          cardBack {
            id
            src
            description
          }
          cardTouch {
            id
            src
            vtt
            description
          }
        }
      }
    }
  }
`;

export default GET_FEELINGS_MATCH_ACTIVITY;
